<div class="functie-card" [ngClass]="{ checked: checked }">
  <div class="functie-card__color-block"></div>
  <a
    title="{{ functie.naam }}"
    *ngIf="
      mode === FunctieCardEnum.DEFAULT || mode === FunctieCardEnum.NONE;
      else isSelectorCardMode
    "
    routerLink="/functie/{{ functie.slug }}"
  >
    <h3 class="functie-card__title">{{ functie.naam }}</h3>
  </a>
  <ng-template #isSelectorCardMode>
    <a title="{{ functie.naam }}" (click)="handlePreviewClick()">
      <h3 class="functie-card__title">{{ functie.naam }}</h3>
    </a>
  </ng-template>

  <div class="functie-card__content">
    <div class="functie-card__description">
      <p>{{ functie.omschrijving }}</p>

      <a
        routerLink="/functie/{{ functie.slug }}"
        data-cy="FunctieDetailsKnop"
        *ngIf="
          mode === FunctieCardEnum.DEFAULT || mode === FunctieCardEnum.NONE
        "
      >
        <span class="functie-card__details-button">
          {{ "functie-card.detailsLinkLabel" | content }}
          <mat-icon class="material-icons">navigate_next</mat-icon>
        </span>
      </a>
      <a
        (click)="handlePreviewClick()"
        data-cy="FunctieDetailsKnop"
        *ngIf="
          mode === FunctieCardEnum.SELECTOR || mode === FunctieCardEnum.DETAIL
        "
      >
        <span class="functie-card__details-button">
          {{ "functie-card.detailsLinkLabel" | content }}
          <mat-icon class="material-icons">navigate_next</mat-icon>
        </span>
      </a>
    </div>

    <div class="functie-card__match-coverage" *ngIf="showMatchPercentage">
      <app-donut-bar
        class="functie-card_donut"
        [value]="functie.matchPercentage"
      >
      </app-donut-bar>

      <div class="functie-card__match-coverage-text">
        <span>{{ "functie-card.matchLabel" | content }}</span>
      </div>
    </div>

    <div class="functie-card__bullits">
      <div class="functie-card__properties">
        <div class="functie-card__bullits-item">
          <mat-icon>school</mat-icon>
          <span>{{ opleidingsniveaus }}</span>
        </div>
        <div
          class="functie-card__bullits-item"
          *ngIf="functie?.salaris?.gte && functie?.salaris?.lte"
        >
          <mat-icon class="material-icons">euro_symbol</mat-icon>
          <span>{{ functie.salaris.gte }} - {{ functie.salaris.lte }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="functie-card__actions" *ngIf="mode !== FunctieCardEnum.NONE">
    <mat-divider></mat-divider>
    <app-button
      *ngIf="mode === FunctieCardEnum.SELECTOR"
      mode="tertiary"
      data-cy="CardSelecteerFunctieLink"
      (clicked)="selectFunctie()"
      [rounded]="false"
    >
      {{ "functie-card.selectorButtonLabel" | content }}
    </app-button>
    <div
      class="functie-card__action--container"
      *ngIf="
        mode === FunctieCardEnum.DEFAULT || mode === FunctieCardEnum.DETAIL
      "
    >
      <div
        class="functie-card__action--vergelijk"
        *ngIf="mode === FunctieCardEnum.DEFAULT"
      >
        <mat-checkbox
          [checked]="checked"
          color="primary"
          (change)="handleCompareSelection($event)"
          data-cy="vergelijkCheckbox"
        >
          {{ "functie-card.compareCheckboxLabel" | content }}
        </mat-checkbox>
      </div>
      <div
        class="functie-card__action--favorite"
        [ngClass]="{
          'favorite-delete': functie.favoriet,
          'favorite-add': !functie.favoriet
        }"
        (click)="handleFavoriteClick()"
      >
        <mat-icon>{{
          functie.favoriet ? "favorite" : "favorite_border"
        }}</mat-icon>
        <span *ngIf="functie.favoriet">
          {{ "functie-card.deleteCheckBoxLabel" | content }}
        </span>
        <span *ngIf="!functie.favoriet">
          {{ "functie-card.saveCheckBoxLabel" | content }}
        </span>
      </div>
    </div>
  </div>
</div>
